import { useEffect, useRef } from "react";
import { solutions } from "../data/siteData";
import "./Solutions.css";

export default function Solutions() {
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("visible"); obs.unobserve(e.target); } }),
      { threshold: 0.1 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
  }, []);

  return (
    <section id="solutions" className="section solutions" ref={ref}>
      <div className="solutions__header reveal">
        <div>
          <span className="section-eyebrow">Crop Solutions</span>
          <h2 className="section-title">Protection Programs<br /><em>by Crop System</em></h2>
        </div>
        <p className="solutions__intro">
          Every crop system faces unique challenges. Our agronomists have built integrated protection
          programs tailored to each — combining the right products at the right timing for maximum yield protection.
        </p>
      </div>
      <div className="solutions__grid reveal">
        {solutions.map((s) => (
          <div className="sol-card" key={s.title}>
            <div className="sol-card__icon-wrap">{s.icon}</div>
            <h3 className="sol-card__title">{s.title}</h3>
            <p className="sol-card__desc">{s.desc}</p>
            <a href="#contact" className="sol-card__link">Learn more →</a>
          </div>
        ))}
      </div>
    </section>
  );
}
